import React from 'react'
import { Box, makeStyles, createStyles, Typography } from '@material-ui/core'
import LegalBasis from './LegalBasis'
import Place from './Place'
import RetentionTime from './RetentionTime'

const DataProcessing = () => {
  // eslint-disable-next-line no-unused-vars
  const classes = useStyles()
  return (
    <Box className={'section'}>
      <Typography variant="h4">
        Mode and place of processing the Data
      </Typography>
      <Typography variant="h6">Methods of processing</Typography>
      <Typography variant="body1">
        The Owner takes appropriate security measures to prevent unauthorized
        access, disclosure, modification, or unauthorized destruction of the
        Data. The Data processing is carried out using computers and/or IT
        enabled tools, following organizational procedures and modes strictly
        related to the purposes indicated. In addition to the Owner, in some
        cases, the Data may be accessible to certain types of persons in charge,
        involved with the operation of this Application (administration, sales,
        marketing, legal, system administration) or external parties (such as
        third-party technical service providers, mail carriers, hosting
        providers, IT companies, communications agencies) appointed, if
        necessary, as Data Processors by the Owner. The updated list of these
        parties may be requested from the Owner at any time.
      </Typography>

      <LegalBasis />

      <Place />

      <RetentionTime />
    </Box>
  )
}

const useStyles = makeStyles((theme) => createStyles({}))

export default DataProcessing
